import React, { useEffect, useState, useRef } from 'react';
import * as Yup from 'yup';
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import PersonalForm from './PersonalForm';
import {
  checkDigit,
  emailRegExp,
  regexName,
  regexPanNumber,
} from '../../../utils/regExp';
import {
  getPersonalInfoReqValue,
  getPersonalInfoResetValue,
  getPersonalInfoSendDetailsReset,
} from './personalInfoAction';
import { checkPanCard } from '../../../utils/utils';
import { getCustomerDetails } from '../Auth/Login/actionLogin';
import { logFirebaseEvent } from '../firebase';
import {
  P2P_BASIC_DETAILS_BTN,
  P2P_BASIC_DETAILS_VIEW,
} from '../firebase/constant';
import { Typography } from '@material-ui/core';
import ProgressBar from '../../../Common/ProgressBar';
import ErrorMessage from '../../../Common/ErrorMessage';
const PersonalInfo = () => {
  const dispatch = useDispatch();
  const formikRef: any = useRef();
  const history = useHistory();
  const [inputType, setInputType] = useState('text');
  const [firstNameAccess, setFirstNameAccess] = useState<boolean>(false);
  const [lastNameAccess, setLastNameAccess] = useState<boolean>(false);
  const [fatherNameAccess, setFatherNameAccess] = useState<boolean>(false);
  const [panNumberAccess, setPanNumberAccess] = useState<boolean>(false);
  const [emailAccess, setEmailAccess] = useState<boolean>(false);
  const [DOBAccess, setDOBAccess] = useState<boolean>(false);
  const [addressAccess, setAddressAccess] = useState<boolean>(false);
  const [pinCodeAccess, setPinCodeAccess] = useState<boolean>(false);
  const [genderAccess, setGenderAccess] = useState<boolean>(false);
  const [aadharNumberAccess, setAadharNumberAccess] = useState<boolean>(false);

  useEffect(() => {
    // logFirebaseEvent(P2P_BASIC_DETAILS_VIEW);
    dispatch(getCustomerDetails(1));
    document.title = 'stashearn - personal-info';
  }, []);

  const { personalInfoData, genderData, error, personalInputValue, personalInfoSendDetails, personalInfoSendDetailsError } =
    useSelector((state: any) => state.personalInfo);

  const { customerData } = useSelector((state: any) => state.login);
  
  useEffect(() => {
    if(personalInfoSendDetails){
      if (personalInfoSendDetails?.status) {
        history.push({ pathname: '/p2p/personalInfoSecond' });
        dispatch(getPersonalInfoSendDetailsReset())
      }
    }
  },[personalInfoSendDetails])

  useEffect(() => {
    if (personalInfoData) {
      if (personalInfoData?.status) {
        history.push({ pathname: '/p2p/connectBank' });
        dispatch(getPersonalInfoResetValue());
      }
    }
    if (customerData && customerData.status) {
      if (
        customerData?.results?.first_name !== '' &&
        customerData?.results?.first_name !== null
      ) {
        setFirstNameAccess(true);
      }
      if (
        customerData?.results?.last_name !== '' &&
        customerData?.results?.last_name !== null
      ) {
        setLastNameAccess(true);
      }
      if(customerData?.results?.father_name !== '' &&
      customerData?.results?.father_name !== null &&  customerData?.results?.father_name !== undefined){
        setFatherNameAccess(true);
      }
      if (
        customerData?.results?.pan_number !== '' &&
        customerData?.results?.pan_number !== null
      ) {
        setPanNumberAccess(true);
      }
      if (
        customerData?.results?.email !== '' &&
        customerData?.results?.email !== null
      ) {
        setEmailAccess(true);
      }
      if (
        customerData?.results?.dob !== '' &&
        customerData?.results?.dob !== null
      ) {
        setDOBAccess(true);
      }
      // if (
      //   customerData?.results?.address_line_1 !== '' &&
      //   customerData?.results?.address_line_1 !== null
      // ) {
      //   setAddressAccess(true);
      // }
      // if (
      //   customerData?.results?.pincode !== '' &&
      //   customerData?.results?.pincode !== null
      // ) {
      //   setPinCodeAccess(true);
      // }
      if (
        customerData?.results?.gender !== '' &&
        customerData?.results?.gender !== null
      ) {
        setGenderAccess(true);
      }
      if (
        customerData?.results?.aadhaar_number !== '' &&
        customerData?.results?.aadhaar_number !== null &&
        customerData?.results?.aadhaar_number !== undefined
      ) {
        setAadharNumberAccess(true);
      }
    }
  }, [personalInfoData, customerData]);

  const initialValues = {
    firstName:
      customerData?.results?.first_name === null
        ? ''
        : customerData?.results?.first_name,
    lastName:
      customerData?.results?.last_name === null
        ? ''
        : customerData?.results?.last_name,
    father_name:
      customerData?.results?.father_name === null
        ? ''
        : customerData?.results?.father_name,
    panNumber:
      customerData?.results?.pan_number === null
        ? ''
        : customerData?.results?.pan_number,
    email:
      customerData?.results?.email === null ? '' : customerData?.results?.email,
    dob: customerData?.results?.dob === null ? '' : customerData?.results?.dob,
    gender:
      customerData?.results?.gender === null
        ? ''
        : customerData?.results?.gender === 'M' ||
          customerData?.results?.gender === 'm'
          ? 'Male'
          : customerData?.results?.gender === 'F' ||
            customerData?.results?.gender === 'f'
            ? 'Female'
            : '',
    // address:
    //   customerData?.results?.address_line_1 === null
    //     ? ''
    //     : customerData?.results?.address_line_1,
    // pincode:
    //   customerData?.results?.pincode === null
    //     ? ''
    //     : customerData?.results?.pincode,
    adharnumber:
      customerData?.results?.aadhaar_number === null
        ? ''
        : customerData?.results?.aadhaar_number,
  };
  const validationSchema = () =>
    Yup.object().shape({
      firstName: Yup.string()
        .matches(regexName, 'invalid first name')
        .required('*Required'),
      lastName: Yup.string()
        .matches(regexName, 'invalid last name')
        .required('*Required'),
      father_name: Yup.string()
      .matches(regexName, 'invalid father name')
      .required('*Required'),
      panNumber: Yup.string()
        .required('*Required')
        .max(10, 'Invalid Pancard Number')
        .min(10, 'Invalid Pancard Number')
        .test('pan-check', 'Invalid Pancard Number', (value) =>
          checkPanCard(value ? value.toUpperCase() : '')
        ),
      email: Yup.string()
        .matches(emailRegExp, 'Invalid email format')
        .max(50, 'Invalid Email')
        .required('*Required'),
      dob: Yup.string().required('*Required'),
      gender: Yup.string().required('*Required'),
      // address: Yup.string().required('*Required'),
      // pincode: Yup.string()
      //   .matches(checkDigit, 'Digits only')
      //   .required('*Required')
      //   .min(6, 'Invalid Pin code'),
      adharnumber: Yup.string()
        .matches(checkDigit, 'Digits only')
        .required('*Required'),
    });

  const onSubmitHandle = (value: any) => {
    dispatch(getPersonalInfoReqValue(value));
    // history.push({ pathname: '/p2p/personalInfoSecond' });
    // logFirebaseEvent(P2P_BASIC_DETAILS_BTN);
   
  };

  const onChangeField = () => {};

  const handleOnFocus = () => {
    setInputType('date');
  };

  const enterKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (formikRef?.current?.isValid) {
        onSubmitHandle(formikRef.current.values);
      }
    }
  };

  return (
    <>
      <BackgroundTheme>
        <Box className='personalInfo'>
          <ProgressBar 
          progress={40}
          />
          <Typography
            variant='h1'
            className='text-blue text-center fs-25 fw-800'
          >
            Let's get to know you <br /> better!
          </Typography>
          <ErrorMessage text={personalInfoSendDetailsError} />
          <PersonalForm
            initialValues={initialValues}
            onSubmitHandle={onSubmitHandle}
            validationSchema={validationSchema}
            onChangeField={onChangeField}
            error={error}
            genderData={genderData}
            personalInputValue={personalInputValue}
            inputType={inputType}
            handleOnFocus={handleOnFocus}
            firstNameAccess={firstNameAccess}
            lastNameAccess={lastNameAccess}
            panNumberAccess={panNumberAccess}
            emailAccess={emailAccess}
            dobAccess={DOBAccess}
            addressAccess={addressAccess}
            pinCodeAccess={pinCodeAccess}
            genderAccess={genderAccess}
            aadharNumberAccess={aadharNumberAccess}
            enterKeyPress={enterKeyPress}
            formikRef={formikRef}
            fatherNameAccess={fatherNameAccess}
          />
        </Box>
      </BackgroundTheme>
    </>
  );
};
export default PersonalInfo;
